import React from "react";
import { Typography } from "antd";
import type { ReactNode } from "react";

const { Text } = Typography;

type Props = {
  children: ReactNode;
};

const Bold = ({ children }: Props): JSX.Element => {
  return (
    <Text strong>{children}</Text>
  );
};

export default Bold;
